import React from "react";
import DarkModeButton from "../dark_mode/dark_mode";
// const DarkModeButton=React.lazy(()=>import( "../dark_mode/dark_mode"));

const QuickAccessTheme = () => {
  return <DarkModeButton />;
};

export default QuickAccessTheme;
